import { useCallback, useEffect, useState } from 'react';

import { Range } from '@app/shared/components';
import type { RangeInterface } from '@app/shared/components/Range/types';

import type { ContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { FilterWrapper } from '@pages/Clients/NewClientsList/ui';

const INITIAL_RANGE: RangeInterface = { from: null, to: null };

export const BalanceFilter: ContentType = ({ open, onClose, id }) => {
  const { filtersMap, onChangeBalanceRange } = useNewClientsListContext();
  const { balanceRange } = filtersMap.get(id)!;

  const [localRange, setLocalRange] = useState<RangeInterface>(INITIAL_RANGE);

  const onConfirm = useCallback(() => {
    onChangeBalanceRange(localRange, id);
    onClose?.();
  }, [id, localRange, onChangeBalanceRange, onClose]);

  useEffect(() => {
    setLocalRange(open ? balanceRange : INITIAL_RANGE);
  }, [open, balanceRange]);

  return (
    <FilterWrapper onConfirm={onConfirm}>
      <Range
        values={localRange}
        onChange={(range) =>
          setLocalRange({ from: range.from ?? null, to: range.to ?? null })
        }
        fromTitle="от"
        toTitle="до"
        min={Number.MIN_SAFE_INTEGER}
        max={Number.MAX_SAFE_INTEGER}
      />
    </FilterWrapper>
  );
};
